import React, { useEffect, useState } from "react";
import $, { param } from "jquery";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useOutletContext } from "react-router-dom";
import useSmartBack from "../../hooks/useSmartBack";

function Candidatelog() {
  const { id } = useParams();
  const { role_id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const REACT_APP_BASE_URL_BACK = process.env.REACT_APP_BASE_URL_BACK;
  const [data, setData] = useState([]);
  const [roles, setRoles] = useState([]);
  const [searchmap, setSearchmap] = useState([]);
  const [clientnotes, setClientNotes] = useState([]);
  const [commentlog, setCommentLog] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [selectedRole, setSelectRole] = useState(null);
  const { setGlobalLoading, token } = useOutletContext();
  const [candidateNotes, setCandidateNotes] = useState([]);
  const [imageUrl,setImageUrl] = useState("")
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const handleBack = useSmartBack(`/candidates/view/${id}`);

  useEffect(() => {
    async function fetchOptions() {
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/candidates/get_candidates_details/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data);
        setData(response.data.emp_detail[0].data || []);
        setRoles(response.data.emp_detail[4].data || []);
        if (response.data.emp_detail[4].data.length > 0) {
          const first_role_id = response.data.emp_detail[4].data[0].role_id;
          setSelectRole(first_role_id);
        }
        console.log(response.data.emp_detail[4].data);
      } catch (error) {
        console.error("API Error:", error);
        setData([]); // Prevent errors from breaking UI
        setRoles([]);
      } finally {
        setGlobalLoading(false); // ✅ Hide loader after API call
      }
    }
    fetchOptions();
  }, [id]);

  useEffect(() => {
    async function fetchlogs() {
      console.log(selectedRole);
      console.log(selectedTab);
      setGlobalLoading(true); //  Show loader before API call
      try {
        const response = await axios.get(
          `${API_BASE_URL}/candidates/get_candidates_logs/${id}/${selectedRole}/${selectedTab}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data.emp_logs);

        setSearchmap(response.data.emp_logs[0].data || []);
        setClientNotes(response.data.emp_logs[1].data || []);
        setCommentLog(response.data.emp_logs[2].data || []);
        setCandidateNotes(response.data.emp_logs[4].data || []);
      } catch (error) {
        console.error("API Error:", error);
        setSearchmap([]);
        setClientNotes([]);
        setCommentLog([]);
      } finally {
        setGlobalLoading(false); // ✅ Hide loader after API call
      }
    }
    fetchlogs();
  }, [selectedRole, selectedTab]);

  const Dp = async (filename) => {
    const response = await fetch(
        `${REACT_APP_BASE_URL_BACK}files/candidates/picture/${filename}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      setImageUrl(url);
  }
  
   useEffect(() => {
      if (!data?.userpic) return;
      console.log("img", data.userpic)
        Dp(data?.userpic)
    }, [data]);

  return (
    <>
      <div className="content">
        <div className="row align-items-center mb-4">
          <div className="col-sm-6">
            <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0"></h6>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-4 theiaStickySidebar">
            <div className="card card-bg-1">
              <div className="card-body p-0">
                <span className="avatar avatar-xl avatar-rounded border border-2 border-white m-auto d-flex mb-2">
                  <img
                    src={imageUrl}
                    className="w-auto h-auto"
                    alt="Img"
                  />
                </span>
                <div className="text-center px-3 pb-3 border-bottom">
                  <h5 className="d-flex align-items-center justify-content-center mb-1">
                    {data.full_name}{" "}
                    <i className="ti ti-discount-check-filled text-success ms-1"></i>
                  </h5>
                  <p className="text-dark">{data.designation}</p>
                </div>
                <div className="p-3 border-bottom">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5>Roles Mapped To</h5>
                  </div>
                  {roles.length > 0
                    ? roles.map((roles, index) => (
                        <div
                          className={`d-flex align-items-center file-name-icon mb-3 p-2 ${
                            roles.role_id == selectedRole
                              ? "border rounded"
                              : ""
                          }`}
                          style={{ cursor: "pointer" }}
                          onClick={() => setSelectRole(roles.role_id)}
                        >
                          <a
                            href="javascript:void(0);"
                            className="avatar avatar-md border rounded-circle"
                          >
                            <img
                              src={`${PINE_BASE_URL}/files/companyLogo/${roles.logo}`}
                              width="75px;"
                              className="img-fluid"
                              alt="Img"
                            />
                          </a>
                          <div className="ms-2">
                            <h6 className="fw-medium">
                              <a onClick={() => setSelectRole(roles?.role_id)}>
                                {roles.role}
                              </a>
                            </h6>
                            <span className="d-block">{roles.company}</span>
                            <span className="d-block">{roles.status}</span>
                          </div>
                        </div>
                      ))
                    : ""}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            <button
              className="btn btn-outline-secondary btn-sm d-inline-flex align-items-center"
              style={{
                cursor: "pointer",
                float: "right",
                position: "relative",
                top: "-55px",
              }}
              onClick={handleBack}
            >
              <i className="ti ti-arrow-left me-2"></i>
              Back
            </button>
            <div>
              <div className="bg-white rounded">
                <ul
                  className="nav nav-tabs nav-tabs-bottom nav-justified flex-wrap mb-3"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <a
                      onClick={() => setSelectedTab(1)}
                      className="nav-link active fw-medium d-flex align-items-center justify-content-center"
                      href="#bottom-justified-tab1"
                      data-bs-toggle="tab"
                      aria-selected="false"
                      role="tab"
                    >
                      <i className="ti ti-activity me-1"></i>
                      Search Map Logs
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      onClick={() => setSelectedTab(2)}
                      className="nav-link fw-medium d-flex align-items-center justify-content-center"
                      href="#bottom-justified-tab2"
                      data-bs-toggle="tab"
                      aria-selected="false"
                      role="tab"
                    >
                      <i className="ti ti-file-description me-1"></i>
                      Client Notes
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      onClick={() => setSelectedTab(3)}
                      className="nav-link fw-medium d-flex align-items-center justify-content-center"
                      href="#bottom-justified-tab3"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                    >
                      <i className="ti ti-message me-1"></i>
                      Comments Logs
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a
                      onClick={() => setSelectedTab(4)}
                      className="nav-link fw-medium d-flex align-items-center justify-content-center"
                      href="#bottom-justified-tab4"
                      data-bs-toggle="tab"
                      aria-selected="true"
                      role="tab"
                    >
                      <i className="ti ti-message me-1"></i>
                      Candidate Notes
                    </a>
                  </li>
                </ul>
              </div>
              <div className="tab-content">
                <div
                  className="tab-pane active show"
                  id="bottom-justified-tab1"
                  role="tabpanel"
                >
                  <div className="card border-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between">
                        <h5>Search Map Logs</h5>
                      </div>
                    </div>
                    {searchmap.length > 0
                      ? searchmap.map((searchmap, index) => (
                          <div
                            className="card-body slimscroll"
                            style={{
                              maxHeight: 15 + "rem",
                              minHeight: 10 + "rem",
                              overflow: "auto",
                            }}
                          >
                            <span className="badge badge-soft-purple d-inline-flex align-items-center mb-2">
                              <i className="ti ti-calendar me-1"></i>
                              {searchmap.formatted_date}
                            </span>
                            <div className="border rounded p-3 mb-2">
                              <div className="d-flex align-items-start">
                                <span className="avatar avatar-md avatar-rounded flex-shrink-0 bg-warning me-2">
                                  <i className="ti ti-file-description fs-20"></i>
                                </span>
                                <div>
                                  <h6 className="fw-medium mb-1">
                                    Notes added by {searchmap.user}
                                  </h6>
                                  <span className="badge badge-soft-info d-inline-flex align-items-center mb-2">
                                    {searchmap.status}
                                  </span>
                                  {searchmap.status == "Offer Accepted" ? (
                                    <div>
                                      <span>
                                        DOJ on {searchmap.date} [
                                        {searchmap.time}]
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  {searchmap?.interviewer ? (
                                    <div>
                                      <h6 className="fw-medium d-flex align-items-center mb-1">
                                        <span className="avatar avatar-md avatar-rounded flex-shrink-0 bg-purple me-2">
                                          <i className="ti ti-user-circle fs-20"></i>
                                        </span>
                                        Meeting With {searchmap.interviewer}
                                      </h6>
                                      <span>
                                        Schedueled on {searchmap.date} [
                                        {searchmap.time}]
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <p className="mb-1">{searchmap.comments}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      : "No Comments Yet"}
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab2"
                  role="tabpanel"
                >
                  <div className="card border-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h5>Client Notes</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="border rounded p-3 mb-3">
                        {clientnotes.length > 0
                          ? clientnotes.map((clientnotes, index) => (
                              <div>
                                <div className="bg-light-500 rounded p-3 mb-3">
                                  <p className="mb-2">{clientnotes.msg}</p>
                                  <p className="text-dark mb-2">
                                    Commented by{" "}
                                    <span className="text-primary">
                                      {" "}
                                      {clientnotes.user}
                                    </span>{" "}
                                    on {clientnotes.created}
                                  </p>
                                </div>
                              </div>
                            ))
                          : "No Notes Yet"}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane"
                  id="bottom-justified-tab3"
                  role="tabpanel"
                >
                  <div className="card border-0">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <h5>Comments Logs</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="border rounded p-3 mb-3">
                        {commentlog.length > 0
                          ? commentlog.map((commentlog, index) => (
                              <div className="border rounded p-3 mb-3">
                                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-3">
                                  <div className="d-flex align-items-center">
                                    <span className="avatar avatar-md avatar-rounded flex-shrink-0 bg-skyblue me-2">
                                      <i className="ti ti-message-circle-2 fs-20"></i>
                                    </span>
                                    <div>
                                      <p className="fw-medium">
                                        <span className="text-dark">
                                          {commentlog.user}{" "}
                                        </span>{" "}
                                        added on {commentlog.created}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <p>{commentlog.comments}</p>
                                </div>
                              </div>
                            ))
                          : "No Logs Yet"}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`tab-pane ${
                    selectedTab === 4 ? "active show" : ""
                  }`}
                  id="bottom-justified-tab4"
                  role="tabpanel"
                >
                  <div className="row">
                    {candidateNotes.length > 0 ? (
                      candidateNotes.map((note, index) => (
                        <div key={index} className="col-md-4 mb-4 d-flex">
                          <div
                            className="card rounded-3 flex-fill d-flex flex-column"
                            style={{ height: "250px" }} // Smaller height for square shape
                          >
                            <div
                              className="card-body p-4 d-flex flex-column"
                              style={{ flexGrow: 1, minHeight: 0 }}
                            >
                              {/* Date */}
                              <div
                                className="d-flex align-items-center justify-content-between mb-3"
                                style={{ flexShrink: 0 }}
                              >
                                <p
                                  className="mb-0 text-muted"
                                  style={{ fontSize: "0.85rem" }}
                                >
                                  <i className="ti ti-calendar me-1"></i>{" "}
                                  {note.dt.substring(0, 10)}
                                </p>
                              </div>

                              {/* Scrollable text area */}
                              <div
                                style={{
                                  overflowY: "auto",
                                  flexGrow: 1,
                                  minHeight: 0,
                                  marginBottom: "1rem",
                                }}
                              >
                                <p className="mb-0">{note.text}</p>
                              </div>

                              {/* Footer with avatar and username */}
                              <div
                                className="d-flex align-items-center border-top pt-3"
                                style={{ flexShrink: 0 }}
                              >
                                <a href="#" className="avatar avatar-md me-2">
                                  <img
                                    className="img-fluid rounded-circle"
                                    src={`${PINE_BASE_URL}/files/media/${
                                      user.userpic || "default.jpg"
                                    }`}
                                    alt="Img"
                                  />
                                </a>
                                <span className="fw-semibold text-primary">
                                  {note.user}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>
                        No Candidate Notes for{" "}
                        <strong>
                          {roles.find((r) => r.role_id === selectedRole)
                            ?.role || "Selected Role"}
                        </strong>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Candidatelog;
